import React from 'react';
import {Link} from 'react-router-dom';
import {UploadImage} from 'components/UI/Image';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import {ShowIf} from 'components/utils';
import {Fairs} from 'api';
import {toastr} from 'react-redux-toastr';
import _ from 'lodash';
import {getPrice} from 'lib/convert';

class ProductBox extends React.Component {

  constructor() {
    super()
    this.state = {
      promotionalPrice: '',
      isOnlyApplyPromotionalPriceFair: false
    }
  }

  componentDidMount() {
    if (this.props.categories && this.props.categories.length === 0 && this.props.addNewProduct === false) {
      let params = {
        filter: {
          include: ['categories']
        }
      }
      Fairs.actions.get.request({id: this.props.match.params.id}, params).then(response => {
        this.props.dispatch({type: 'UPDATE_CATEGORIES_OF_FAIR', data: response.data.fair.categories})
      })
    }
  }

  onModify() {
    this.props.onModify && this.props.onModify(this.props.id);
  }

  onDelete() {
    this.props.onDelete && this.props.onDelete(this.props.id);
  }

  getCategory(listCategoryId) {
    let categories = listCategoryId.map(item => {
      return this.props.categories && this.props.categories.findIndex(category => category.id === item.substring(4)) !== - 1 && this.props.categories[this.props.categories.findIndex(category => category.id === item.substring(4))].name || null
    })
    return categories
  }

  onChange(value) {
    if (value === false) {
      this.removeFeaturedProduct()
    } else {
      this.setFeaturedProduct()
    }
  }

  setFeaturedProduct() {
    this.props.setFeaturedProduct(this.props.id)
  }

  removeFeaturedProduct() {
    this.props.removeFeaturedProduct(this.props.id)
  }

  accept(productId) {
    this.props.accept(productId)
  }

  unAccept(productId) {
    this.props.unAccept(productId)
  }

  lock(productId) {
    this.props.unAccept(productId, 'lock')
  }

  unLock(productId) {
    this.props.accept(productId, 'lock')
  }

  // deprecated
  getPrice(value) {
    String.prototype.splice = function(idx, rem, str) {
      return this.slice(0, idx) + str + this.slice(idx + Math.abs(rem));
    };
    let result = value;
    if(String(result).length < 3) {
      return result
    } else {
      for (let j = Number(String(result).length); j > 0;) {
        j = j - 3;
        if(j > 0) {
          result = String(result).splice(j, 0, ",");
        }
      }
      return result
    }
  }

  inputChange(name, e) {
    this.setState({[name]: e.target.value})
  }

  onAddNew() {
    this.props.onAddNew({id: this.props.id, promotionalPrice: this.state.promotionalPrice, isOnlyApplyPromotionalPriceFair: this.state.isOnlyApplyPromotionalPriceFair})
  }

  onRemove() {
    this.props.onRemove({id: this.props.id})
  }

  onChangeCheckbox() {
    this.setState({isOnlyApplyPromotionalPriceFair: !this.state.isOnlyApplyPromotionalPriceFair})
  }

  render() {
    return (
      <div className={`products`}>
        <div className="image">
          <UploadImage type="PRODUCT" width="177" height="127" image={this.props.images[this.props.images.length -1]} />
        </div>
        <p className="name">{this.props.name}</p>
        {this.props.addNewProduct || (this.props.price && !this.props.promotionalPrice) ?
          <p className="price">
            GIÁ: {getPrice(this.props.price)}
            {!this.props.addNewProduct && this.props.price && !this.props.promotionalPrice &&
              <button className="btn-change ml15 glyphicon glyphicon-pencil" onClick={this.onModify.bind(this)}></button>
            }
          </p>
          :
          <p className="price">GIÁ: {getPrice(this.props.promotionalPrice)}<button className="btn-change ml15 glyphicon glyphicon-pencil" onClick={this.onModify.bind(this)}></button></p>
        }
        <ShowIf condition={this.props.showDescription}>
          <p className="desc">{this.props.description}</p>
        </ShowIf>
        <ShowIf condition={this.props.addNewProduct === false} >
          <div className='wrap-btn'>
            <ShowIf condition={this.props.categories.length > 0}>
              <p className="category"><strong>Danh mục:</strong> {this.getCategory(this.props.dntCategoryIds || [])}</p>
            </ShowIf>
            <ShowIf condition={this.props.isFeatured === false}>
              <button className='btn-highlight' onClick={this.onChange.bind(this, true)}><i className='fa fa-star'/> Đặt làm sản phẩm nổi bật</button>
            </ShowIf>
            <ShowIf condition={this.props.isFeatured === true}>
              <button className='btn-highlight red' onClick={this.onChange.bind(this, false)}><i className='fa fa-star'/> Hủy sản phẩm nổi bật</button>
            </ShowIf>
            <ShowIf condition={this.props.status === 1}>
              <button className='btn-highlight red' onClick={this.lock.bind(this, this.props.id)}>Tạm khóa sản phẩm</button>
            </ShowIf>
            <ShowIf condition={this.props.status === 2}>
              <button className='btn-highlight red' onClick={this.unLock.bind(this, this.props.id)}>Cho phép sản phẩm tham gia hội chợ</button>
            </ShowIf>
            <ShowIf condition={this.props.status === 0}>
              <div className='action-panel'>
                <button className='btn btn-primary ml15' onClick={this.accept.bind(this, this.props.id)}>Duyệt</button>
                <button className='btn btn-danger ml15' onClick={this.unAccept.bind(this, this.props.id)}>Từ chối</button>
              </div>
            </ShowIf>
          </div>
        </ShowIf>
        <ShowIf condition={this.props.addNewProduct !== false} >
          <div>
            <div className='input-group'>
              <label>Nhập giá sản phẩm trên hội chợ</label>
              <input type='text' value={this.state.promotionalPrice} onChange={this.inputChange.bind(this, 'promotionalPrice')} />
            </div>
            <div className='input-group wrap-input'>
              <input type='checkbox' checked={this.state.isOnlyApplyPromotionalPriceFair ? true : false} onChange={this.onChangeCheckbox.bind(this)} />
              <label>Giá chỉ áp dụng cho hội chợ</label>
            </div>
            <div className='wrap-btn'>
              <ShowIf condition={_.findIndex(this.props.selectedProducts, (item) => item.id === this.props.id) !== -1}>
                <button className='btn-highlight red' onClick={this.onRemove.bind(this, this.props.id)}>Hủy bỏ</button>
              </ShowIf>
              <ShowIf condition={_.findIndex(this.props.selectedProducts, (item) => item.id === this.props.id) === -1}>
                <button className='btn-highlight' onClick={this.onAddNew.bind(this, this.props.id)}>Thêm sản phẩm này</button>
              </ShowIf>
            </div>
          </div>
        </ShowIf>
      </div>
    );
  }
}

const mapStateToProps = function(state) {
  return {
    categories: state.fairs.categories
  };
}

ProductBox.propTypes = {
  showDescription: PropTypes.bool,
  showRequestButton: PropTypes.bool,
  enableSendRequest: PropTypes.bool,
  enableAddProduct: PropTypes.bool,
  saleProduct: PropTypes.bool
};

ProductBox.defaultProps = {
  showDescription: true,
  showRequestButton: true,
  enableSendRequest: true,
  enableAddProduct: false,
  saleProduct: false,
  delete: false,
  actionPanel: null,
  categories: [],
  addNewProduct: false
};

export default connect(mapStateToProps)(ProductBox);



// WEBPACK FOOTER //
// ./components/fair/fair-product/ProductBox.jsx